// src/hooks/ProductionSessionProvider.js
import { useEffect } from 'react';

export default function ProductionSessionProvider({ children }) {
  // This provider does ABSOLUTELY NO session checking
  // Perfect for production pages
  
  useEffect(() => {
    console.log('ProductionSessionProvider: No session checks here!');
  }, []);
  
  return children;
}